import { RootState } from 'app/store';

export const selectFieldLabels = (state: RootState) => state.fieldLabels.labels;
